import { BlocksIconFlash } from 'blocks-nextjs/blocks-web-components/components/icon/icons/flash';
import React from 'react';
import { createComponent } from '../../CustomWrapper/CustomWrapper';

export const CatIconFlash = createComponent({ react: React, tagName: 'cat-icon-flash', elementClass: BlocksIconFlash });
